"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UICloseButton = _interopRequireDefault(require("../button/UICloseButton"));

var _sizes = require("HubStyleTokens/sizes");

var _colors = require("HubStyleTokens/colors");

var _Use = require("./utils/Use");

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _memoWithDisplayName = _interopRequireDefault(require("../utils/memoWithDisplayName"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  margin-left: ", ";\n  right: 0;\n  left: 0;\n  top: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CLOSE_BUTTON_USE_COLOR_MAP = {
  default: _colors.EERIE,
  shepherd: _colors.OLAF,
  longform: _colors.CALYPSO,
  tooltip: _colors.OLAF,
  'tooltip-danger': _colors.OLAF,
  unstyled: _colors.EERIE
};
var StyledCloseButton = (0, _styledComponents.default)(_UICloseButton.default).withConfig({
  displayName: "UIPopoverCloseButton__StyledCloseButton",
  componentId: "affire-0"
})(_templateObject(), function (_ref) {
  var size = _ref.size;
  return size === 'sm' ? _sizes.SMALL_CLOSE_BUTTON_SIZE : _sizes.MEDIUM_CLOSE_BUTTON_SIZE;
}, function (_ref2) {
  var size = _ref2.size;
  return (size === 'sm' ? 0 : parseInt(_sizes.POPOVER_PADDING_X, 10) - parseInt(_sizes.POPOVER_PADDING_Y, 10)) + "px";
});
var UIPopoverCloseButton = (0, _memoWithDisplayName.default)('UIPopoverCloseButton', function (_ref3) {
  var popoverUse = _ref3.popoverUse,
      size = _ref3.size,
      rest = (0, _objectWithoutProperties2.default)(_ref3, ["popoverUse", "size"]);
  var computedColor = CLOSE_BUTTON_USE_COLOR_MAP[popoverUse];
  var shorthandSize = (0, _tshirtSize.toShorthandSize)(popoverUse === 'longform' ? 'sm' : size);
  return _react.default.createElement(StyledCloseButton, (0, _extends2.default)({
    color: computedColor,
    size: shorthandSize
  }, rest));
});
UIPopoverCloseButton.propTypes = {
  color: _propTypes.default.string,
  size: _UICloseButton.default.propTypes.size,
  popoverUse: _propTypes.default.oneOf(Object.keys(_Use.USE_CLASSES))
};
UIPopoverCloseButton.defaultProps = {
  size: 'md',
  popoverUse: 'default'
};
var _default = UIPopoverCloseButton;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3773/js/tooltip/UIPopoverCloseButton.js
// module id = 197
// module chunks = 0